export default __webpack_public_path__ + "static/media/valueProposal.b500eef6.svg";